import { Avatar, Box, Chip, CircularProgress, Stack } from "@mui/material";
import { IconSearch } from "@tabler/icons-react";
import { useState } from "react";
import Text from "../../../../../../components/ui/Text";
import { PLAYER_ROLES } from "../../../../../../constants/game";
export const Members = ({
  members,
  pagination,
  loading,
  loadingMore,
  observerRef,
}) => {
  const [searchMembers, setSearchMembers] = useState("");
  // const [memberMenuAnchor, setMemberMenuAnchor] = useState(null);
  // const [selectedMemberId, setSelectedMemberId] = useState(null);

  const handleMemberSearch = (event) => {
    setSearchMembers(event.target.value);
  };
  const filteredMembers = members?.filter((member) => {
    const search = searchMembers.toLowerCase();
    return (
      (member.first_name || "").toLowerCase().includes(search) ||
      (member.last_name || "").toLowerCase().includes(search) ||
      (member.email || "").toLowerCase().includes(search)
    );
  });

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          py: 4,
        }}
      >
        <CircularProgress size={40} />
      </Box>
    );
  }

  if (!members || members.length === 0) {
    return <Text variant="paragraph">No members in this group.</Text>;
  }

  return (
    <>
      <Stack spacing={3}>
        {/* Search Bar */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            backgroundColor: "white",
            border: "1px solid #A1A1A1",
            borderRadius: "2px",
            px: 2,
            py: 1,
          }}
        >
          <IconSearch size={22} color="#A1A1A1" />
          <Box
            component="input"
            placeholder="Search members"
            value={searchMembers}
            onChange={handleMemberSearch}
            sx={{
              border: "none",
              outline: "none",
              backgroundColor: "transparent",
              fontSize: "16px",
              flex: 1,
              "&::placeholder": {
                color: "#A1A1A1",
              },
            }}
          />
        </Box>

        {/* Members List - Using GameDetails player card format */}
        <Stack spacing={2}>
          {filteredMembers?.map((member) => (
            <Box
              key={member.id}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                bgcolor: "white",
                p: 1,
                borderRadius: "8px",
              }}
            >
              <Avatar
                src={member?.profile_image_url}
                sx={{ width: 40, height: 40, fontSize: "16px" }}
              >
                {member?.first_name?.[0]?.toUpperCase()}
                {member?.last_name?.[0]?.toUpperCase()}
              </Avatar>
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Text
                  variant="paragraph"
                  sx={{ fontSize: "16px", fontWeight: 500 }}
                >
                  {member.first_name} {member.last_name}
                </Text>
              </Box>
              {member.role === PLAYER_ROLES.HOST && (
                <Chip
                  label="Host"
                  size="small"
                  sx={{
                    backgroundColor: "#E6F4FF",
                    color: "#1890FF",
                    fontSize: "12px",
                    px: 1,
                    height: "24px",
                  }}
                />
              )}
            </Box>
          ))}

          {pagination.has_next_page && (
            <Box
              ref={observerRef}
              id="load-more-anchor"
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                py: 3,
              }}
            >
              {loadingMore ? (
                <CircularProgress size={32} />
              ) : (
                <Box sx={{ opacity: 0, height: "1px" }}>Anchor</Box>
              )}
            </Box>
          )}
        </Stack>
      </Stack>
    </>
  );
};
